module.exports = __webpack_public_path__ + "static/img/yakum.0557f8c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/yakum.png
// module id = jle7
// module chunks = 1